export default "__VITE_ASSET__F4_pepc7__"